class Session
  answer_ready: (description) =>
    @controller.debug_log(@side + ' send answer_ready')
    @peer_connection.setLocalDescription(description)
    message = {
      type: 'stream_answer',
      description: {
        type: description.type,
        sdp: description.sdp,
      },
    }
    @controller.send_message(message, @session_id, @target_session_id)

  check_queue: =>
    @controller.read_queue(@session_id)

  constructor: (controller, session_id) ->
    @controller = controller
    @session_id = session_id
    @check_queue_interval_id = setInterval(@check_queue, @controller.poll_interval)

  connect: ->
    @controller.read_queue(@session_id)
    @peer_connection = @controller.create_peer_connection()
    @peer_connection.onicecandidate = @on_ice_candidate

  connected: ->
    clearInterval(@check_queue_interval_id)

  handle_message_ice_candidate: (message) =>
    @controller.debug_log(@side + ' got ice candidate')
    ice_candidate = new RTCIceCandidate(message.candidate)
    @peer_connection.addIceCandidate(ice_candidate)

  handle_message_stream_answer: (message) =>
    @controller.debug_log(@side + ' got stream answer')
    stream_description = new RTCSessionDescription(message.description)
    @peer_connection.setRemoteDescription(stream_description)

  handle_message_stream_offer: (message) =>
    @controller.debug_log(@side + ' got stream offer')
    @controller.debug_log(message)
    stream_description = new RTCSessionDescription(message.description)
    @peer_connection.setRemoteDescription(stream_description)
    @peer_connection.createAnswer(@answer_ready, @controller.error_handler)

  on_ice_candidate: (event) =>
    if (event.candidate)
      candidate = event.candidate
      message = {
        type: 'ice_candidate',
        candidate: {
          candidate: candidate.candidate,
          sdpMid: candidate.sdpMid,
          sdpMLineIndex: candidate.sdpMLineIndex,
        }
      }
      @controller.send_message(message, @session_id, @target_session_id)

    
class KioskSession extends Session
  constructor: (controller, session_id, target_session_id) ->
    super(controller, session_id)
    @target_session_id = target_session_id

  connect: ->
    super()
    @send_session_started()
    @controller.debug_log(@controller.stream)
    @peer_connection.addStream(@controller.stream)
    @peer_connection.createOffer(@offer_ready, @controller.error_handler)
    @peer_connection.oniceconnectionstatechange  = @on_ice_connection_state_change

  offer_ready: (description) =>
    @controller.debug_log(@side + ' offer ready')
    @peer_connection.setLocalDescription(description)
    message = {
      type: 'stream_offer',
      description: {
        type: description.type,
        sdp: description.sdp,
      }
    }
    @controller.send_message(message, @session_id, @target_session_id)

  on_ice_connection_state_change: (event) =>
    if @peer_connection.iceConnectionState == 'connected'
      @connected()

  send_session_started: () =>
    message = {
      type: 'session_started',
      session_id: @session_id
    }
    @controller.send_message(message, @session_id, @target_session_id)


class OperatorSession extends Session
  connect: ->
    super()
    @peer_connection.onaddstream = @on_add_stream
    @send_start_session()

  handle_message_session_started: (message) =>
    @target_session_id = message['session_id']

  on_add_stream: (event) =>
    @video = document.querySelector("video")
    @video.src = window.URL.createObjectURL(event.stream)
    $('#capture-button').removeAttr('disabled')
    @connected()

  send_start_session: ->
    @controller.debug_log('sending start_session')
    message = {
      type: 'start_session',
      session_id: @session_id,
    }
    @controller.send_message(message, @session_id)

 
class GroupFacilityAuthorizationController
  ajax_error: (jq_xhr, text_status, error_thrown) =>
    $('.error-messages').append("<div>jq_xhr: <pre>" + jq_xhr + "</pre>text_status: <pre>" + text_status + "</pre>error_thrown: <pre>" + error_thrown + "</pre></div>")

  capture: =>
    canvas = document.createElement('canvas')
    result = $('body').append(canvas)
    video = $('video').get(0)
    canvas.height = video.videoHeight
    canvas.width = video.videoWidth
    context = canvas.getContext('2d')
    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
    data = {
      card_id: @card_id,
      image: canvas.toDataURL('image/png'),
    }
    args = {
      data: data,
      dataType: 'json',
      error: @ajax_error,
      success: @capture_result,
      type: 'POST',
      url: "/group_facility_authorization/" + @kiosk_id + "/capture.json",
    }
    $.ajax(args)

  capture_result: (data, text_status, jq_xhr) =>
    if (@handle_errors(data, text_status, jq_xhr))
      return
    window.location = data['redirect']

  check_queue: () =>
    @read_queue()

  connect_to_video: () =>
    session_id = @create_session_id()
    @debug_log('creating operator with session_id ' + session_id)
    session = new OperatorSession(this, session_id)
    session.connect()
    @sessions[session_id] = session

  constructor: (kiosk_id, side, card_id = null) ->
    @debug_mode = true
    @poll_interval = 500
    @kiosk_id = kiosk_id
    @side = side
    @card_id = card_id
    @sessions = {}
    @stream = null
    if @side == 'kiosk'
      @start_video()

  create_peer_connection: ->
    config = {
      'iceServers': [
        {'url': 'stun:stun-turn.bikelink.org'}
      ]
    }
    return new RTCPeerConnection(config)

  create_session_id: ->
    return new Date().getTime()

  debug_log: (value) =>
    if @debug_mode
      console.log(value)

  error_handler: (error) =>
    $('error-messages').append("<div>" + error + "</div>")

  handle_errors: (data, text_status, jq_xhr) =>
    if (data['errors'].length != 0)
      for error_message in data['errors']
        $('.error-messages').append("<div>" + error_message + "</div>")
      return true
    else
      return false

  handle_message: (message) =>
    @debug_log(message)
    payload = JSON.parse(message)
    method_name = "handle_message_" + payload["type"]
    @debug_log(method_name)
    @debug_log(payload)
    if 'target_session_id' of payload
      session_id = payload['target_session_id']
      session = @sessions[session_id]
      method = session[method_name]
      method(payload)
    else
      method = this[method_name]
      method(payload)

  handle_message_start_session: (message) =>
    session_id = @create_session_id()
    session = new KioskSession(this, session_id, message['session_id'])
    @sessions[session_id] = session
    session.connect()

  read_queue: (session_id = null) =>
    @debug_log(@side + ' read_queue for ' + session_id)
    url = "/group_facility_authorization/" + @kiosk_id + "/read_queue.json?side=" + @side
    if session_id != null
      url += "&session_id=" + session_id
    args = {
      dataType: 'json',
      error: @ajax_error,
      success: @read_queue_result,
      type: 'GET',
      url: url,
    }
    $.ajax(args)

  read_queue_result: (data, text_status, jq_xhr) =>
    if (@handle_errors(data, text_status, jq_xhr))
      return
    for message in data['messages']
      @handle_message(message)

  resize_verify_images: () =>
    spacing_width = 30
    id_image = $('#id-image')
    person_image = $('#person-image')
    ratio = 1280 / 1024
    width = $(window).width() - spacing_width
    height = Math.round(width / ratio)
    height_percent = height / ($(window).height() - spacing_width)
    width_percent = width / ($(window).width() - spacing_width)

    if height_percent < 1.0 && height_percent >= width_percent
      height = $(window).height() - spacing_width
      width = Math.round(height * ratio)
    else if width_percent < 1.0 && width_percent > height_percent
      width = $(window).width() - spacing_width
      height = Math.round(width / ratio)

    id_image.width(width * 0.75)
    id_image.height(height * 0.75)
    person_image.width(width * 0.25)
    person_image.height(height * 0.25)


  send_message: (message, session_id, target_session_id = null) ->
    @target_side = 'kiosk'
    if @side == 'kiosk'
      @target_side = 'operator'
    message['session_id'] = session_id
    if target_session_id != null
      message['target_session_id'] = target_session_id
    data = {
      message: JSON.stringify(message),
      session_id: session_id,
      side: @side,
      target_side: @target_side,
      target_session_id: target_session_id,
    }
    args = {
      data: data,
      dataType: 'json',
      error: @ajax_error,
      success: @send_message_result,
      type: 'POST',
      url: "/group_facility_authorization/" + @kiosk_id + "/send_message.json",
    }
    $.ajax(args)

  send_message_result: (data, text_status, jq_xhr) =>
    @handle_errors(data, text_status, jq_xhr)

  start_video: ->
    constraints = {
      audio: false,
      video: {
        "mandatory": {
          minWidth: "320",
          minHeight: "200",
        },
      }
    }
    getUserMedia(constraints, this.video_started, this.error_handler)

  video_started: (stream) =>
    video = document.querySelector("video")
    @stream = stream
    video.src = window.URL.createObjectURL(stream)
    video.play()
    setInterval(@check_queue, @poll_interval)

module.exports = GroupFacilityAuthorizationController
